import { Form, Drawer, Switch, Button, Radio, Space } from "antd";
import { useAppDispatch } from "../../app/hooks";
import { useEffect, useState } from "react";
import * as styles from "./UserStudyCreationStyle";
import { study } from "../../API/UserManagement/Study";
import ReusableForm from "../../unity-ui-common/Components/ReForm";
import ReInput from "../../unity-ui-common/Components/ReFormFields/ReInput";
import ReSelect from "../../unity-ui-common/Components/ReFormFields/ReSelect";
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";
import { tenant } from "../../API/UserManagement/Tenant";
import {
  convertDateInReadableFormat,
  GetRoleName,
  getSelectedTenant,
} from "../../Helper/Methods";
import { ICreateStudy } from "../../Interfaces/Apis/Study.interface";
import { StudyPhase, StudyType, BlindingTechinique, Blinded } from "./common";
import { getstudies } from "../../slices/User/Helpers/GetAllStudy";

import ReRadioGroup from "../../unity-ui-common/Components/ReFormFields/ReRadioGroup";
import { product } from "../../API/UserManagement/Product";

export const UserStudyCreationForm = (props: {
  drawerType: string;
  visibility: boolean;
  setStudyDrawerType: Function;
  setStudyDrawerVisibility: Function;
  currEditingStudy: any;
  studyData: any;
  setCommonRefresh:React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [form] = Form.useForm();
  const {
    drawerType,
    visibility,
    setStudyDrawerType,
    setStudyDrawerVisibility,
    currEditingStudy,
    studyData,
    setCommonRefresh
  } = props;

  const dispatch = useAppDispatch();

  const initialFormValues = {
    studyNumber: "",
    studyName: "",
    blinded: undefined,
    studyProduct: [],
    status: 1,
    blindingTechnique: "",
    studyType: "",
    studyPhase: "",
    registrationAuthority: "",
    sponsor: getSelectedTenant()?.[0]?.id || "",
  };
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [tempStudy, setTempStudy] = useState<ICreateStudy>(initialFormValues);
  const [selectedSponsors, setSelectedSponsors] = useState<any[]>([]);
  const [editable, setEditable] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [blinded, setBlinded] = useState(false);

  const handleBlindedChange = (value: boolean) => {
    setBlinded(value);
  };

  useEffect(() => {
    setEditable(drawerType == "create" || drawerType == "edit");
  }, [drawerType]);

  const handleSelectChanges = (type: string, value: string[]) => {
    // const data = value.map((id: string) => ({
    //   name: GetRoleName(id, type === "role" ? allRoles : allSponsors),
    //   value: id,
    // }));
    // const tenantId = JSON.parse(
    //   sessionStorage.getItem("selectedTenant") || "{}"
    // )?.id;
    /* if (drawerType === "create")  {
    // setSelectedRoles(data);
    const updatedRoleMatrices = tempUser.roleMatrices.map((matrix) => ({
      tenant: matrix.tenant,
      roles: matrix.roles.filter((role) =>
        data.some((selected) => selected.value === role)
      ),
    }));
    const updatedRoleMatrices = [
      {
        tenant: tenantId,
        roles: value,
      },
    ];
    setTempUser((prevData) => ({
      ...prevData,
      roleMatrices: updatedRoleMatrices,
    }));
    }
    else {
      // setSelectedSponsors(data);
      // const allIds = data.map((ele) => ele.value);
      // const filtered = tempUser.roleMatrices.filter((mt) =>
      //   allIds.includes(mt.tenant)
      // );
      // const updatedMatrices = studyData.roleMatrices.map((matrix: any) => {
      //   if (matrix.tenant === tenantId) {
      //     return {
      //       ...matrix,
      //       roles: value
      //     };
      //   }
      //   return matrix;
      // });
      // setTempUser((prevData: any) => ({
      //   ...prevData,
      //   roleMatrices: updatedMatrices,
      // }));
    }*/
  };

  const onClose = () => {
    setStudyDrawerType("create");
    setStudyDrawerVisibility(false);
    form.resetFields();
  };

  const handleFormSubmit = async (values: any) => {
    // debugger;
    setSubmitLoading(true);
    setCommonRefresh(false)

    const payload = {
      studyNumber: values?.studyNumber,
      studyName: values?.studyName?.trim() || "",
      blinded: values.blinded,
      sponsor: getSelectedTenant()?.[0]?.id,
      studyType: values?.studyType ? values?.studyType : "",
      studyPhase: values?.studyPhase ? values?.studyPhase : "",
      studyProduct: values?.studyProduct,
      status: tempStudy?.status,
      blindingTechnique:
        values?.blindingTechnique && values.blinded
          ? values?.blindingTechnique
          : "",
      registrationAuthority: values?.registrationAuthority,
    };
    if (drawerType === "create") {
      let res = await study.createStudy(payload);
      if (res?.statusCode > 300 || res?.status === false) {
        ReNotification({
          description: res?.message || "Something went wrong",
          type: "error",
        });
        setSubmitLoading(false);
        return;
      }

      ReNotification({
        description: "Record Created Successfully",
        type: "success",
      });

      setStudyDrawerType("create");
      setSubmitLoading(false);
      setCommonRefresh(true)
      setStudyDrawerVisibility(false);
      onClose();
      dispatch(getstudies());
    } else {
      const updatePayload = { ...payload, id: currEditingStudy.id };

      let res = await study.updateStudy(currEditingStudy.id, updatePayload);
      res = await res?.json();
      if (res?.statusCode > 300) {
        ReNotification({
          description: res?.message || "Something went wrong",
          type: "error",
        });
        setSubmitLoading(false);
        return;
      }
      dispatch(getstudies());
      ReNotification({
        description: "Study Updated Successfully",
        type: "success",
      });
      setCommonRefresh(true)
      setSubmitLoading(false);
      setStudyDrawerType("create");
      setStudyDrawerVisibility(false);
      onClose();
    }
  };

  // const getRoles = async () => {
  //   const res = await role.getAll();
  //   setAllRoles(res);
  // };
  // const getCountries = async () => {
  //   const res = await ruleEngine.getCountries();
  //   setCountry(res)
  // }
  const getProducts = async () => {
    const res = await product.getAllProducts();
    setAllProducts(Array.isArray(res) ? res : []);
  };
  useEffect(() => {
    //getRoles();
    getProducts();
    //getCountries();
  }, []);

  const handleRefresh = () => {
    if (drawerType === "view") {
      const tenantId = JSON.parse(
        sessionStorage.getItem("selectedTenant") || "{}"
      )?.id;

      setTempStudy({
        studyNumber: currEditingStudy?.studyNumber,
        studyName: currEditingStudy?.studyName,
        blinded: currEditingStudy?.blinded,
        studyType: currEditingStudy?.studyType,
        studyProduct: Array.isArray(currEditingStudy?.studyProduct) ? currEditingStudy?.studyProduct : (typeof currEditingStudy?.studyProduct === 'string' ? currEditingStudy?.studyProduct.split(',').map((s: string) => s.trim()).filter(Boolean) : []),
        studyPhase: currEditingStudy?.studyPhase,
        registrationAuthority: currEditingStudy?.registrationAuthority,
        blindingTechnique: currEditingStudy?.blindingTechnique,
        status: currEditingStudy?.status,
        sponsor: currEditingStudy?.sponsor?.id,
        sponserName: currEditingStudy?.sponsor?.name,
      });
      form.setFieldsValue({
        studyNumber: currEditingStudy?.studyNumber,
        studyName: currEditingStudy?.studyName,
        blinded: currEditingStudy?.blinded,
        studyType: currEditingStudy?.studyType,
        studyProduct: Array.isArray(currEditingStudy?.studyProduct) ? currEditingStudy?.studyProduct : (typeof currEditingStudy?.studyProduct === 'string' ? currEditingStudy?.studyProduct.split(',').map((s: string) => s.trim()).filter(Boolean) : []),
        studyPhase: currEditingStudy?.studyPhase,
        registrationAuthority: currEditingStudy?.registrationAuthority,
        blindingTechnique: currEditingStudy?.blindingTechnique,
        status: currEditingStudy?.status,
        sponsor: currEditingStudy?.sponsor?.id,
      });
    } else {
      setTempStudy(initialFormValues);
      //setSelectedRoles([]);
      setSelectedSponsors([]);
      form.setFieldsValue(initialFormValues);
    }
  };

  useEffect(() => {
    handleRefresh();
  }, [drawerType]);

  return (
    <styles.Container>
      <div className="common-flex-row justify-end user-creation-form">
        <Drawer
          placement="right"
          onClose={onClose}
          open={visibility}
          width="1000"
          title={drawerType === "edit" ? "Edit Study" : "Study Number"}
        >
          <ReusableForm
            formInstance={form}
            onSubmit={handleFormSubmit}
            className="form"
          >
            {!editable && (
              <div className="formItem">
                <span>Study ID: </span>
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {currEditingStudy?.id ? currEditingStudy?.id : "-"}
                  </styles.ViewOnlyDiv>
                </div>
              </div>
            )}
            {/*-----------study number---------------*/}
            <div className="formItem">
              <span>
                <styles.RequiredAsterisk>*</styles.RequiredAsterisk>
                Study Number:{" "}
              </span>
              {editable ? (
                <div className="formInput">
                  <ReInput
                    name="studyNumber"
                    label=""
                    type="simple"
                    textItem="Study Number"
                    required
                  />
                </div>
              ) : form.getFieldValue("studyNumber") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("studyNumber")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>
            {/* <ReInput label="Name" name="name" type="simple" required /> */}

            {/*-----------study name---------------*/}
            <div className="formItem">
              <span>
                <styles.RequiredAsterisk>*</styles.RequiredAsterisk>
                Study Name:{" "}
              </span>
              {editable ? (
                <div className="formInput">
                  <ReInput
                    name="studyName"
                    label=""
                    type="simple"
                    textItem="Study Name"
                    required
                  />
                </div>
              ) : form.getFieldValue("studyName") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("studyName")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------study Product---------------*/}
            <div className="formItem">
              <span>
                <styles.RequiredAsterisk>*</styles.RequiredAsterisk>
                Study Product:{" "}
              </span>
              {editable ? (
                <div className="formInput">
                  {/* <ReInput
                    name="studyProduct"
                    label=""
                    type="simple"
                    textItem="Study Product"
                    required
                  /> */}
                  <ReSelect
                    label=""
                    name="studyProduct"
                    type="multiple"
                    items={allProducts?.map((product: any) => {
                      return {
                        title: product?.name,
                        value: product?.name,
                      };
                    })}
                    textItem="Study Product"
                    required
                    searchable
                  />
                </div>
              ) : form.getFieldValue("studyProduct") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {Array.isArray(form.getFieldValue("studyProduct")) 
                      ? form.getFieldValue("studyProduct").join(", ") 
                      : form.getFieldValue("studyProduct") || "-"}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------blinded---------------*/}
            <div className="formItem">
              <span>
                <styles.RequiredAsterisk>*</styles.RequiredAsterisk>
                Blinded:{" "}
              </span>
              {editable ? (
                <div className="formInput">
                  <ReSelect
                    label=""
                    name="blinded"
                    items={Blinded?.map((blinded: any) => {
                      return {
                        title: blinded.title,
                        value: blinded.value,
                      };
                    })}
                    textItem="Blinded"
                    required
                    onChange={handleBlindedChange}
                  />
                </div>
              ) : form.getFieldValue("blinded") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {`${form.getFieldValue("blinded")}`}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{`${form.getFieldValue(
                  "blinded"
                )}`}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------blinding technique---------------*/}
            <div className="formItem">
              <span>Blinding Technique: </span>
              {editable ? (
                <div className="formInput">
                  <ReRadioGroup
                    label=""
                    name="blindingTechnique"
                    items={BlindingTechinique?.map((Techinique: any) => {
                      return {
                        title: Techinique.title,
                        value: Techinique.value,
                        disable: blinded === false,
                      };
                    })}
                  />
                </div>
              ) : form.getFieldValue("blindingTechnique") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("blindingTechnique")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------study phase---------------*/}
            <div className="formItem">
              <span>Study Phase: </span>
              {editable ? (
                <div className="formInput">
                  <ReSelect
                    label=""
                    name="studyPhase"
                    items={StudyPhase?.map((phase: any) => {
                      return {
                        title: phase.title,
                        value: phase.value,
                      };
                    })}
                    textItem="StudyPhase"
                  />
                </div>
              ) : form.getFieldValue("studyPhase") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("studyPhase")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------study type---------------*/}
            <div className="formItem">
              <span>Study Type: </span>
              {editable ? (
                <div className="formInput">
                  <ReSelect
                    label=""
                    name="studyType"
                    items={StudyType?.map((studyType: any) => {
                      return {
                        title: studyType.title,
                        value: studyType.value,
                      };
                    })}
                    textItem="StudyType"
                  />
                </div>
              ) : form.getFieldValue("studyType") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("studyType")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>

            {/*-----------Study Registration Authority---------------*/}
            <div className="formItem">
              <span>Study Registration Authority: </span>
              {editable ? (
                <div className="formInput">
                  <ReInput
                    name="registrationAuthority"
                    label=""
                    type="simple"
                    textItem="Study Registration Authority"
                  />
                </div>
              ) : form.getFieldValue("registrationAuthority") ? (
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {form.getFieldValue("registrationAuthority")}
                  </styles.ViewOnlyDiv>
                </div>
              ) : (
                <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
              )}
            </div>
            {/*-----------Last Modified Date---------------*/}
            {!editable && (
              <div className="formItem">
                <span>Last Modified Date:</span>
                <div
                  className="formData"
                  style={{ paddingTop: "4px", paddingBottom: "5px" }}
                >
                  <styles.ViewOnlyDiv>
                    {currEditingStudy?.updatedAt ? (
                      convertDateInReadableFormat(currEditingStudy?.updatedAt)
                    ) : (
                      <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
                    )}
                  </styles.ViewOnlyDiv>
                </div>
              </div>
            )}

            {/*-----------status---------------*/}
            <Form.Item label="" rules={[{ required: true }]} required>
              <div className="formItem">
                <span>
                  <styles.RequiredAsterisk>*</styles.RequiredAsterisk>
                  Status:{" "}
                </span>
                {editable ? (
                  <div className="formInput">
                    <Switch
                      checked={tempStudy?.status === 1}
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                      onChange={(checked) => {
                        setTempStudy((prevData) => ({
                          ...prevData,
                          status: checked ? 1 : 0,
                        }));
                      }}
                    />
                  </div>
                ) : form.getFieldValue("status") ? (
                  <div
                    className="formData"
                    style={{ paddingTop: "4px", paddingBottom: "5px" }}
                  >
                    {" "}
                    <styles.ViewOnlyDiv>
                      {form.getFieldValue("status") === 1
                        ? "Active"
                        : "Inactive"}
                    </styles.ViewOnlyDiv>
                  </div>
                ) : (
                  <styles.ViewOnlyDiv>{"-"}</styles.ViewOnlyDiv>
                )}
              </div>
              {drawerType !== "create" &&
                (!editable ? (
                  <Button
                    style={{ marginTop: "1rem" }}
                    type="primary"
                    size="middle"
                    onClick={() => {
                      setEditable(true);
                    }}
                  >
                    Edit
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      setEditable(false);
                      handleRefresh();
                    }}
                  >
                    Back
                  </Button>
                ))}
              {editable && (
                <Button
                  style={{
                    marginTop: "1rem",
                    marginLeft: `${drawerType !== "create" && "0.5rem"}`,
                  }}
                  size="middle"
                  loading={submitLoading}
                  type="primary"
                  onClick={() => {
                    form.submit();
                  }}
                >
                  {drawerType !== "create" ? "Update" : "Create"}
                </Button>
              )}
            </Form.Item>
          </ReusableForm>
        </Drawer>
      </div>
    </styles.Container>
  );
};
